module.exports = __webpack_public_path__ + "static/media/action--big.01832dfe.png";